module.exports = __webpack_public_path__ + "c_static/img/tip2.0e790e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/tip2.png
// module id = aNZ+
// module chunks = 33